import React from 'react';
import clsx from 'clsx';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import useStyles from './assetStyle';

export default function AccordinDet10() {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [country, setCountry] = React.useState('Enter Country');

    const handleChange = (event) => {
        setCountry(event.target.value);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const [formValues, setFormValues] = React.useState({
        country: 'Enter Country Name',
        instiName: 'Enter Name',
        instiAddr: 'Enter Address',
        zip: 'Enter ZIP Code',
        date: 'Pick Date',
        cashValue: 'Enter the cash value',
        grossValue: 'Enter detail',
    });

    return (
        <Grid container spacing={2} className="main-container">
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    <InputLabel className={classes.inLabel} htmlFor="country-name">
                        Country Name
                    </InputLabel>
                    <Select
                        disabled
                        id="country-name"
                        className={classes.bottomLine}
                        value={country}
                        open={open}
                        onClose={handleClose}
                        onOpen={handleOpen}
                        onChange={handleChange}
                        IconComponent={() => <FontAwesomeIcon icon={faAngleDown} />}
                    >
                        <MenuItem value="Enter Country">Enter Country</MenuItem>
                        <MenuItem value="India">India</MenuItem>
                        <MenuItem value="Nepal">Nepal</MenuItem>
                        <MenuItem value="Sri Lanka">Sri Lanka</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    <InputLabel className={classes.inLabel} htmlFor="insti-name">
                        Name of financial institution in which insurance contract held
                    </InputLabel>
                    <Input disabled className={classes.bottomLine} id="insti-name" value={formValues.instiName} />
                </FormControl>
            </Grid>
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    <InputLabel className={classes.inLabel} htmlFor="insti-addr">
                        Address of financial institution
                    </InputLabel>
                    <Input disabled className={classes.bottomLine} id="insti-addr" value={formValues.instiAddr} />
                </FormControl>
            </Grid>
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    <InputLabel className={classes.inLabel} htmlFor="zip">
                        ZIP code
                    </InputLabel>
                    <Input disabled className={classes.bottomLine} id="zip" value={formValues.zip} />
                </FormControl>
            </Grid>
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    {/* <InputLabel className={classes.inLabel} htmlFor="date">Date of contract</InputLabel>
                        <Input
                            disabled
                            className={classes.bottomLine}
                            id="date"
                            value={formValues.date}
                        /> */}
                    <TextField
                        id="date"
                        label="Date of contract"
                        type="date"
                        defaultValue="Enter date"
                        InputProps={{ classes: { root: classes.bottomLine }, disabled: true }}
                        InputLabelProps={{
                            classes: {
                                root: classes.inLabel,
                            },
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    <InputLabel className={classes.inLabel} htmlFor="cash-value">
                        The cash value or surrender value of the contract
                    </InputLabel>
                    <Input disabled className={classes.bottomLine} id="cash-value" value={formValues.cashValue} />
                </FormControl>
            </Grid>
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    <InputLabel className={classes.inLabel} htmlFor="gross-value">
                        Total gross amount paid / credited with respect to the contract during the period
                    </InputLabel>
                    <Input disabled className={classes.bottomLine} id="gross-value" value={formValues.grossValue} />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} className={classes.marginBtm}>
                <Button variant="outlined" color="primary" className={clsx(classes.button, classes.btnGrey)}>
                    Add More
                </Button>
            </Grid>
        </Grid>
    );
}
